<template>
  <div>
    <sticky v-if="contact" class="page-header sticky-page-header page-header--new" :back-button="true">
      <div slot="left">
        <h1 class="title is-3">
          <router-link :to="{name: 'ContactList'}"
                       class="has-text-weight-normal is-uppercase">Fiche contact
          </router-link>
        </h1>
      </div>
      <router-link :to="{name: 'ContactEdit', params: {id: c.pk}}" class="dropdown-item" slot="dropdown-content">
        <span class="icon"><i class="fas fa-user-edit"></i></span>
        <span>Modifier fiche</span>
      </router-link>
      <a slot="dropdown-content" @click="openQuickView" class="dropdown-item">
        <span class="icon"><i class="fas fa-search-location"></i></span>
        <span>Critère de recherche</span>
      </a>
      <a slot="dropdown-content" @click="newRdv" class="dropdown-item" v-if="!isExternal">
        <span class="icon"><i class="fas fa-calendar-plus"></i></span>
        <span>Création rendez-vous</span>
      </a>
      <a @click="addReferent" v-if="isAdmin || isManager" class="dropdown-item" slot="dropdown-content">
            <span class="icon">
              <i class="fas fa-exchange"></i>
            </span>
        <span v-if="c.seller">Modifier l'utilisateur référent</span>
        <span v-else>Assigner à un utilisateur</span>
      </a>
      <a @click.prevent.stop="deleteContact" class="dropdown-item has-text-danger"
         slot="dropdown-content">
        <span class="icon"><i class="fas fa-trash-alt"></i></span>
        <span>Supprimer contact</span>
      </a>
    </sticky>
    <spinner-round :isLoading="loading" v-if="loading"></spinner-round>
    <div v-if="!loading && c"
      class="columns is-padding-left-on-btn-actions is-padding-right-on-btn-actions has-stickyColumn has-stickyColumn--left">
      <div class="column is-4 is-3-fullhd is-paddingless-left is-paddingless-right">
        <div class="card has-bg-white is-bordered">
          <div class="columns is-vcentered">
          </div>
          <div class="is-padding-top is-padding-left is-padding-right is-padding-bottom has-text-centered">
            <figure class="image is-128x128 is-margin-auto has-picto has-picto--top2Right">
              <div class="dot is-large tooltip is-tooltip-right has-bg-success"
                   :class="checkCompleteBuyer(c) ? 'has-bg-success' : 'has-bg-warning'"
                   :data-tooltip="checkCompleteBuyer(c) ? 'Fiche complète' : 'Fiche incomplète'">
                <span class=""><!--<i class="fal fa-fire fa-lg has-text-white"></i>--></span>
              </div>
              <div class="is-border is-border-circle is-border-transparent is-clipped">
                <img v-if="c.picture" :src="c.picture|avatarBig">
                <div v-else style="width:126px; height:126px; line-height:126px"
                     class="has-bg-light-darken-2 has-text-white is-clipped is-relative">
                  <i class="is-absolutecenter fas fa-user-crown fa-6x"></i>
                </div>
              </div>
            </figure>
            <div class="title is-3 is-margin-top-xsmall is-marginless-bottom"><b>{{c.first_name}} {{c.last_name}}</b>
            </div>
            <div class="is-margin-bottom is-margin-top-xsmall is-size-5 has-text-weight-light"><span
              v-if="c.age && c.age > 0">{{c.age}} ans </span><span
              v-if="c.profession && (c.age && c.age > 0)">-</span><span v-if="c.profession"> {{c.profession}}</span>
            </div>
            <div v-show="nbrCommentaireTotal > 0" class="has-text-center">
              <button class="button is-info is-small is-radius-large is-size-6"
                      @click="changePanel(PANELS.INFOS)">
                <span class="icon is-small"><i class="fas fa-comment-alt"></i></span>
                <span>{{nbrCommentaireTotal}} commentaire<span v-show="nbrCommentaireTotal > 1">s</span></span>
              </button>
            </div>
          </div>
          <div class="columns is-multiline is-border-top">
            <div class="column is-12 is-paddingless-bottom">
              <div class="columns is-gapless">
                <div class="column is-size-6 is-narrow w80p is-margin-right-xsmall"><b>Adresse :</b></div>
                <div class="column is-size-6" v-if="c.address && c.address.city && c.address.zip_code">
                  <span v-if="c.address.line1">{{c.address.line1}}<br></span>
                  {{c.address.zip_code}} {{c.address.city}} <i>{{c.address.country}}</i>
                </div>
              </div>
            </div>
            <div class="column is-12 is-paddingless-bottom is-padding-top-xsmall">
              <div class="columns is-gapless">
                <div class="column is-size-6 is-narrow w80p is-margin-right-xsmall"><b>Mail :</b></div>
                <div class="column is-size-6" v-if="c.email">
                  <a class="is-underline is-break-word" :href="'mailto:'+c.email">{{c.email}}</a>
                </div>
              </div>
            </div>
            <div class="column is-12 is-padding-top-xsmall">
              <div class="columns is-gapless">
                <div class="column is-size-6 is-narrow w80p is-margin-right-xsmall"><b>Téléphone :</b></div>
                <div class="column is-size-6" v-if="c.mobile || c.phone">
                  <span v-if="c.mobile">{{c.mobile|prettyPhone}}</span><span
                  v-if="c.mobile && c.phone"> - </span><span v-if="c.phone">{{c.phone|prettyPhone}}</span>
                </div>
              </div>
            </div>
            <div class="column is-12 is-border-top">
              <b>Utilisateur référent :</b>
              <span class="">
                <router-link v-if="c.seller_name && c.seller_name.length"
                             :to="{name: 'UserVue', params: {id: c.seller}}"> {{c.seller_name}}</router-link>
                 <a v-else @click="addReferent" class="is-underline">Spécifier Référent</a>
              </span>
            </div>
            <div class="column is-12 is-border-top columns is-column is-space-between"
                 v-if="!isExternal">
              <div class="has-text-grey is-size-6">Origine</div>
              <div class="is-margin-top-xsmall is-size-6" v-if="c.origin">{{c.origin_name}}</div>
              <div class="is-margin-top-xsmall is-size-6" v-else>--
                <router-link :to="{name: 'ContactEdit', params: {id: c.pk}}" class="is-underline"><i>Sélectionner</i>
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <div v-if="isAdmin && events && events.length">
          <event-tracker-list :show-list="showLastEvents" :events="lastEvents"
                              :last-event="lastEvent"
                              :show-all="!!fullHistory && !!fullHistory.length"
                              @showAll="getFullHistory"
                              @toggle="showLastEvents = !showLastEvents">
          </event-tracker-list>
          <!-- <div class="column is-10 is-padding-top-small is-padding-bottom-small" >
            <div class=" is-size-7 has-text-grey">
              Modifié le :
              <b>{{reversedHistory[0].created_on|prettyDate}}</b>
              à {{reversedHistory[0].created_on|prettyTime}}
            </div>
          </div>
          <div class="column is-2 is-padding-top-small is-padding-bottom-small has-text-right">
            <i class="fal fa-history has-text-grey is-size-6"></i>
          </div> -->
        </div>
      </div>
      <div class="column is-8 is-9-fullhd is-paddingless-right">
        <div class="has-bg-white is-border">
          <div
            class="tabs is-separatedUnderlined is-marginless-bottom is-radius-top-left is-radius-top-right is-clipped">
            <ul class="has-text-weight-medium">
              <li :class="{'is-active' : panel === PANELS.HISTORY}">
                <a @click="changePanel(PANELS.HISTORY)">Historique</a>
              </li>
              <li :class="{'is-active' : panel === PANELS.INFOS}">
                <a @click="changePanel(PANELS.INFOS)">Informations</a>
              </li>
              <li :class="{'is-active' : panel === PANELS.SEARCH}">
                <a @click="changePanel(PANELS.SEARCH)">Recherches</a>
              </li>
              <li :class="{'is-active' : panel === PANELS.OPTION}" v-if="options && options.length">
                <a @click="changePanel(PANELS.OPTION)">Options</a>
              </li>
              <li :class="{'is-active' : panel === PANELS.SALES}">
                <a @click="changePanel(PANELS.SALES)">Achats</a>
              </li>
              <li :class="{'is-active' : panel === PANELS.RDV}" v-if="rdvs && rdvs.length && !isExternal">
                <a @click="changePanel(PANELS.RDV)">Rendez-vous</a>
              </li>
            </ul>
          </div>
          <router-view :source-contact="c"
                       :source-history="c.history"
                       :source-options="options"
                       :source-denunciations="denunciations"
                       :source-rdvs="rdvs"
                       :source-searchs="searchs"
                       :source-sales="sales"
                       :source-spouse="spouse"
                       @reloadContact='loadContact'
                       @reloadRdvs="reloadRdvs"
                       @updateRdv="updateRdv"
                       @updateSpouse="updateSpouse"
          ></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ContactHistory from './ContactRightPanel/ContactHistory'
  import ContactInformations from './ContactRightPanel/ContactInformations'
  import ContactOptionList from './ContactRightPanel/ContactOptionList'
  import ContactSearchList from './ContactRightPanel/ContactSearchList'
  import ContactRdvList from './ContactRightPanel/ContactRdvList'
  import ContactSalesList from './ContactRightPanel/ContactSalesList'

  import { mapGetters, mapState } from 'vuex'
  import { DefaultValues, Error, EventTrackerMx } from '@/mixins'
  import { reverse } from 'lodash'

  const PANELS = Object.freeze({
    INFOS: 'ContactInformations',
    HISTORY: 'ContactHistory',
    OPTION: 'ContactOption',
    SEARCH: 'ContactSearch',
    RDV: 'ContactRdv',
    SALES: 'ContactSales'
  })

  export default {
    name: 'ContactVue',
    props: {},
    data () {
      return {
        page: null,
        returnId: null,
        loading: false,
        contact: null,
        spouse: null,
        service: this.$api.contactService,
        showModal: false,
        PANELS: PANELS,
        searchs: [],
        options: [],
        rdvs: [],
        denunciations: [],
        sales: []
      }
    },
    mixins: [DefaultValues, Error, EventTrackerMx],
    computed: {
      ...mapState(['quickview']),
      ...mapGetters(['isExternal', 'isAdmin', 'isManager']),
      c () {
        return this.contact
      },
      eventEntity () {
        return this.c
      },
      contactPk () {
        return this.$route.params.id
      },
      reversedHistory () {
        return reverse(this.c.history)
      },
      panel () {
        return this.$route.name
      },
      id () {
        return this.$route.params.id
      },
      nbrCommentaireTotal () {
        if (this.rdvs && Array.isArray(this.rdvs) && this.rdvs.length) {
          let rdvsComment = this.rdvs.map(x => {
            if (x.note || x.report_note) return {}
          }).filter(x => x)
          let total = 0
          total += (this.c.comment && this.c.comment.length) ? 1 : 0
          total += (rdvsComment && rdvsComment.length) ? rdvsComment.length : 0
          return total
        }
      }
    },
    components: {
      ContactHistory,
      ContactInformations,
      ContactOptionList,
      ContactSearchList,
      ContactRdvList,
      ContactSalesList
    },
    watch: {
      '$route' (to, from) {
        if (to.params.id !== from.params.id) {
          this.loadContact()
        }
        if (this.$route.name === 'ContactVue') {
          this.changePanel(PANELS.HISTORY)
        }
      },
      quickview ({ mode, params, results }) {
        if (results) {
          if (mode === 'SELLER_SELECTION') {
            this.contact.seller = results.entities[0].pk
            this.service.put(this.contact.pk, this.contact).then(r => {
              Object.assign(this.contact, r.data)
              this.$notify({
                type: 'is-success',
                text: 'Le vendeur a été ajouté au contact'
              })
            })
          }
        }
      }
    },
    methods: {
      changePanel (panel) {
        this.$router.replace({ name: panel })
        this.$router.replace({ query: { returnId: this.returnId, page: this.page } })
      },
      loadContact () {
        if (this.$route.name === 'ContactVue') {
          if (this.$route.query.returnId) this.returnId = this.$route.query.returnId
          if (this.$route.query.page) this.page = this.$route.query.page
          this.changePanel(PANELS.HISTORY)
        }
        this.loading = true
        this.service.getOne(this.$route.params.id).then(r => {
          this.loading = false
          this.contact = r.data
          if (r.data.spouse) this.getSpouse(r.data.spouse)
          this.getItems()
        }).catch(r => {
          this.loading = false
          this.$router.replace({ name: 'NotFound' })
        })
      },
      getSpouse (id) {
        this.service.getOne(id).then(r => {
          this.spouse = r.data
        })
      },
      openQuickView () {
        this.$store.commit('setQuickview', { mode: 'NEW_CONTACT_SEARCH', params: { contact: this.contact } })
      },
      newRdv () {
        let params = {
          contact: this.contact.pk
        }
        this.$router.push({ name: 'CalendarCreate', query: params })
      },
      addReferent () {
        let params = {
          facets: {
            'USER': ['is_editor:False', 'is_operator:False']
          },
          mode: 'store'
        }
        this.$store.commit('setQuickview', { mode: 'SELLER_SELECTION', params })
      },
      deleteContact () {
        const d = {
          title: 'Suppression',
          text: 'Êtes vous sûr de vouloir supprimer ce contact ?',
          confirmButtonText: 'Supprimer'
        }
        this.$swal(d).then(r => {
          if (r.value) {
            this.service.delete(this.contactPk).then(res => {
              this.loading = false
              this.$router.push({ name: 'ContactList' })
            }).catch(err => {
              this.handleError(err)
              this.loading = false
            })
          }
        })
      },
      async getItems () {
        this.loading = true
        let promises = [
          this.service.getResearches({ buyer: this.id }),
          this.$api.advService.get({ buyer: this.id }),
          this.$api.denunciationService.get({ buyer: this.id }),
          this.$api.optionService.get({ buyer: this.id })
        ]
        if (!this.isExternal) {
          promises.push(this.$api.rdvService.get({ contact: this.id }))
        }
        await Promise.all(promises).then(([
                                            search,
                                            sale,
                                            denunciations,
                                            option,
                                            rdv
                                          ]) => {
          this.loading = false
          this.searchs = search.data.items
          this.sales = sale.data.items
          this.denunciations = denunciations.data.items
          this.options = option.data.items
          if (rdv) {
            this.rdvs = rdv.data.items
          }
        })
      },
      reloadRdvs () {
        this.$api.rdvService.get({ contact: this.id }).then(r => {
          this.rdvs = r.data
        })
      },
      updateRdv (rdv) {
        let idx = this.rdvs.findIndex(x => x.pk === rdv.pk)
        if (idx >= 0) {
          this.rdvs.splice(idx, 1, rdv)
        } else {
          this.reloadRdvs()
        }
      },
      checkCompleteBuyer (buyer) {
        if (!buyer) return
        if (buyer.nature === 'corporation') {
          return (buyer.corporation_name !== null || buyer.corporation_name !== '') &&
            (buyer.corporation_siret !== null || buyer.corporation_siret !== '') &&
            buyer.last_name !== null && buyer.last_name !== '' &&
            buyer.first_name !== null && buyer.first_name !== '' &&
            buyer.birth_name !== null && buyer.birth_name !== '' &&
            buyer.address !== null && buyer.address !== '' &&
            buyer.address.line1 !== null && buyer.address.line1 !== '' &&
            buyer.address.zip_code !== null && buyer.address.zip_code !== '' &&
            buyer.address.city !== null && buyer.address.city !== '' &&
            (buyer.csp === 'unemployed' || buyer.csp === 'retirement'
              ? true : buyer.profession !== null && buyer.profession !== '')
        } else {
          return buyer.last_name !== null && buyer.last_name !== '' &&
            buyer.birth_name !== null && buyer.birth_name !== '' &&
            buyer.first_name !== null && buyer.first_name !== '' &&
            buyer.address !== null && buyer.address !== '' &&
            buyer.address.line1 !== null && buyer.address.line1 !== '' &&
            buyer.address.zip_code !== null && buyer.address.zip_code !== '' &&
            buyer.address.city !== null && buyer.address.city !== '' &&
            buyer.birthday !== null && buyer.birthday !== '' &&
            buyer.nationality !== null && buyer.nationality !== '' &&
            buyer.birthplace !== null && buyer.birthplace !== '' &&
            buyer.family_situation !== null && buyer.family_situation !== '' &&
            buyer.income !== null && buyer.income !== '' &&
            buyer.is_owner !== null && buyer.is_owner !== '' &&
            buyer.tax_income !== null && buyer.tax_income !== '' &&
            buyer.land_income !== null && buyer.land_income !== '' &&
            (buyer.csp === 'unemployed' || buyer.csp === 'retirement'
              ? true : buyer.profession !== null && buyer.profession !== '') &&
            (buyer.family_situation === 'married'
              ? (buyer.matrimonial_status !== null && buyer.matrimonial_status !== '') &&
              (buyer.wedding_date !== null && buyer.wedding_date !== '') &&
              (buyer.wedding_place !== null && buyer.wedding_place !== '')
              : true) &&
            (buyer.family_situation === 'pacs'
              ? (buyer.matrimonial_status !== null && buyer.matrimonial_status !== '') &&
              (buyer.wedding_date !== null && buyer.wedding_date !== '') &&
              (buyer.wedding_place !== null && buyer.wedding_place !== '')
              : true)
        }
      },
      updateSpouse (val) {
        this.service.patch(this.id, { spouse: val }).then(async r => {
          let { data } = await this.service.getOne(val)
          this.spouse = data
          this.$notify({
            type: 'is-success',
            text: 'Conjoint(e) du contact mis à jour.'
          })
        })
      }
    },
    created () {
      this.loadContact()
      if (this.$route.query.panel) {
        this.changePanel(PANELS[this.$route.query.panel])
      }
    }
  }
</script>

<style>

  .historic .menu span {
    border-radius: 0;
    color: #0e152c;
    display: block;
    padding: 0.75em 0.75em;
    background-color: #f7f7f7;
  }

</style>



// WEBPACK FOOTER //
// src/components/contact/ContactVue.vue